import { render, staticRenderFns } from "./AvailabilityFullCalendar.vue?vue&type=template&id=64c6d04c&scoped=true"
import script from "./AvailabilityFullCalendar.vue?vue&type=script&lang=js"
export * from "./AvailabilityFullCalendar.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityFullCalendar.vue?vue&type=style&index=0&id=64c6d04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6d04c",
  null
  
)

export default component.exports